import React from 'react';
import { InfoModal } from '../../components/ExpandActions/InfoModal';
import { ApiServerDocumentation } from './ApiServerDocumentation';
import { useApiServerHelp } from '../../components/ExpandActions/context/ApiServerHelpContext';

export const ApiServerHelpUsage = () => {
  const { isOpen, data, closePortal } = useApiServerHelp();

  if (!data) return null;

  return (
    <InfoModal
      isOpen={isOpen}
      onClose={closePortal}
      title="API Server Flow Documentation"
      description="Learn about your API Server flow configuration and how to interact with it programmatically."
    >
      <ApiServerDocumentation data={data} />
    </InfoModal>
  );
};
